module.exports = __webpack_public_path__ + "toGroom-we-g-n.4035f1b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-g-n.jpg
// module id = B0cS
// module chunks = 0